

<div class="pipeline_reg-top">
  <!-- top left part  -->

  <div class="log">
    <h2 class="title">Pipeline</h2>
      <div class="history" >
        <div class="" *ngIf="pipelineDetail && pipelineDetail.length && task === 'create' ">
          <p class="created_by" *ngIf="pipelineDetail[0]?.CreatedUser != null ">
            Created By:
            <span class="name">{{pipelineDetail[0]?.CreatedUser.StaffName}} </span>
            <span class="time">({{pipelineDetail[0]?.dateCreated | date:'M/d/yyyy'}})</span>
          </p>
          <p class="modified_by" *ngIf="pipelineDetail[0]?.ModifyUser != null">
            Modified By:
            <span class="name">{{pipelineDetail[0]?.ModifyUser.StaffName}} </span>
            <span class="time">({{pipelineDetail[0]?.dateUpdated | date:'M/d/yyyy'}})</span>
          </p>
        </div>
        <!-- <button class="default_secondary-btn history_btn">See History <em class="ti-time"></em> </button> -->
      </div>
  </div>

  <!-- top right part -->

  <div class="filter_search">
    <div class="search_container">
      <input type="text"  #search class="default_input search search_land" placeholder="Search" />
      <em class="ti-search"></em> 
    </div>
    <input type="checkbox" style="cursor: pointer;" #myCheckbox color="primary">
    <button class="default_secondary-btn Add_new" (click)="createEvent()">Create New<em class="ti-plus"></em> </button>
    <button class="default_secondary-btn Add_new" (click)="toggleUploadPanel()">Upload<em class="ti-upload"></em> </button>
  </div>

  <div *ngIf="showUploadPanel">
     <!-- <input  -->

     <div>

      <label for="avatar">Choose a file:</label>

      <input type="file"
             id="avatar" name="avatar" (change)="onFileChange($event)"
            >
     </div>



      <div>
        <button class="default_secondary-btn Add_new" [ngClass]="{ 'inactive_btn': (gatewayService.isLoading$ | async) }" [disabled]="(gatewayService.isLoading$ | async)" (click)="submit()" >Submit<em class="ti-upload"></em> </button>


        <div *ngIf="(gatewayService.isLoading$ | async)">
          <mat-progress-spinner mode="indeterminate" diameter='30' strokeWidth='1' ></mat-progress-spinner>
        </div>
      </div>

  </div>
</div>
